export default __webpack_public_path__ + "../img/finn_splash2.jpg";